import { connect } from 'react-redux';
import React, { Component } from 'react';

import InfoBar from './InfoBar';
import SpecEditor from './SpecEditor';
import Scrollable from './Scrollable';

import {Tabs, Tab, IconButton} from 'material-ui';
import {NavigationChevronLeft, NavigationChevronRight} from 'material-ui/svg-icons';
import ResponsePopup from './ResponsePopup';

class ApiViewer extends Component {
  render() {
    const height = this.props.height - 64;
    return (
      this.props.edit_mode ?
        <Tabs>
          <Tab onActive={this.props.onToggleTab} label='Documentation' value='documentation'>
          {this.props.active !== 'documentation' ? null :
            <Scrollable height={height}>
              <div className='unselectable'>
                <InfoBar/>
                {this.props.children}
              </div>
            </Scrollable>
          }
          </Tab>
          <Tab onActive={this.props.onToggleTab} label='Editor' value='editor'>
          {this.props.active !== 'editor' ? null :
            <Scrollable height={height}>
              <SpecEditor/>
            </Scrollable>
          }
          </Tab>
        </Tabs> :
        <div>
          <ResponsePopup/>
          <Scrollable height={height}>
            <div className='unselectable'>
              <InfoBar/>
              {this.props.children}
            </div>
          </Scrollable>
        </div>
    );
  }
}

export default connect(
  state => (
    {
      edit_mode: state.getIn(['apis', 'edit_mode']),
      active: state.get('tabs').get('active'),
      height: state.get('window').get('height'),
      fullscreen: state.get('window').get('fullscreen')
    }
  ),
  dispatch => (
    {
      onToggleTab(tab) {
        dispatch({type: 'SWITCH_TAB', data: tab});
      }
    }
  )
)(ApiViewer);
